import React from "react";
import { View1099 } from "./View1099/View1099";
import { LoansAndNotes } from "./LoansAndNotes";
import "./Modal.css";

function ModalComponent ({ modalToShow, setOpenModal, viewer, loans }) {
	return (
		<div>
			<div className="modalBackground">
				<div className="modalContainer">
					<div className="title">
						<button
							type="button"
							className="btn-close close"
							onClick={() => { setOpenModal(false); }}>
							<span aria-hidden="true">x</span>
						</button>
						<h4 className="modal-title">{modalToShow}</h4>
					</div>
					<div className="body">
						{modalToShow === "1099s"
							? <View1099 viewer={viewer} />
							: <LoansAndNotes loans={loans} />
						}
					</div>
					<div className="footer">
						<button
							className="btn btn-default"
							onClick={() => { setOpenModal(false); }}
							id="cancelBtn">
                            Close
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ModalComponent;